// import Vue from 'vue'
// import { ACCESS_TOKEN } from '@/store/mutation-types'
import {
  // NoticeThirdSystem,
  SsoGetUserInfo,
   SsogetUserRoleMenu,
  SsoUserChooseSubject,
  QuerySystemExtListForSub
} from '@/api/login'
import {
  // i18nRender,
  loadLanguageAsync
} from '@/locales'
import { openNotificationWithIcon } from '@/utils/util'
// import modal from 'ant-design-vue/es/modal'
import Vue from 'vue'
import router from '../router'
import { LANGUAGE } from './mutation-types'

const isLogin = {
  state: {
    isTips: false,
    islogin: false,
    isRegister: false,
    isForget: false,
    menus: [],
    activeKey: '',
    isCallme: false,
    hideInfo: {}, // 个人信息
    panes: [],
    docContent: {},
    docList: [],
    searchObj: {},
    documentId: '',
    catalogId: '',
    isRegSeccess: false,
    isPasSeccess: false,
    lang: '', // 語言
    personalData: {}, // 存储当前用户认证信息
    meunList: [], // 工作台左侧展示列表
    meunIsLoading: false, // 工作台菜单loading
    childMenu: [], // 权限菜单 自
    pagePrimission: {},
    isChoiceSubject: false, // 是否切换企业主体
    subjectId: '', // 当前选中 企业主体id
    subjectName: '', // header显示的企业主体 名称
    isCredentials: false, // 是否需要认证
    isBuy: false,
    toOtherMenu: false, // 是否有权限跳转其他页面
    isFixedBtn: false, // 按钮是否在固定底部
    DocCenterMeunIsLoading: false, // 文档中心菜单loading
    services: []
  },
  mutations: {
    ON_LOGIN: (state, type) => {
      state.isTips = true
      if (type === 'login') {
        state.islogin = true
        state.isRegister = false
        state.isPasSeccess = false
      } else {
        state.isRegister = true
        state.islogin = false
      }
      state.isForget = false
    },
    SET_ISBUY: (state, item) => {
      state.isBuy = item
    },
    SET_LANGUAGE: (state, lang) => {
      state.lang = lang
      Vue.ls.set(LANGUAGE, lang)
    },
    SET_IS_FIXED_BTN: (state, isFixedBtn) => {
      state.isFixedBtn = isFixedBtn
    },
    OFF_LOGIN: (state) => {
      setTimeout(() => {
        state.isTips = false
        state.isForget = false
        state.isRegSeccess = false
      }, 300)
    },
    ON_FORGOT (state) {
      state.isForget = true
      state.islogin = false
      state.isRegister = false
    },
    DOCDETAIL: (state, data) => {
      state.docContent = data
    },
    SERACHDOC: (state, searchObj) => {
      state.docList = searchObj.list ? searchObj.list : []
      state.searchObj = searchObj
    },
    // 存储当前企业认证信息
    SET_COMPANY_INFO: (state, data) => {
      state.personalData = data
    },
    // 左侧列表权限
    SET_LEFT_MENU: (state, data) => {
      // if (!data) {
      //   state.meunList = []
      //   return
      // }
      const primissions = {}
      function deepMenu (arr = [], parent = {}) {
          // console.log('arr', arr)
          if (arr === null) arr = []
          let menus = []
          for (let item of arr) {
            const childMenus = deepMenu(item?.childMenus, item)
            if (item.lastMenu === 2 && item.menuType === 1) {
              primissions[item.menuUrl] = item.menuId
            }
            if (item.lastMenu === 1 && item.menuType === 2) {
              item.functionClass && (primissions[item.functionClass] = item.menuId)
            }
            if (childMenus?.length) {
              menus.push({
                ...item,
                childMenus
              })
            }
          }
          return menus
      }
      // deepMenu()
      // state.meunList = data.filter(item => item.menuStatus === 1).sort((a, b) => a.menuSort - b.menuSort)
      // console.log('data', data)
      if (data?.length) {
        deepMenu(data)
        const allMenu = data.filter(item => item.menuStatus === 1).sort((a, b) => a.menuSort - b.menuSort)
        // console.log('allMenu', allMenu)
        state.meunList = allMenu
        state.pagePrimission = primissions
        console.log('primissions111', primissions)
      } else {
        state.meunList = []
        // resolve([])
      }
      console.log('state.meunList', state.meunList)
      // state.childMenu = []
      // data.map((item) => {
      //   let funcArray = []
      //   if (item.childMenus) {
      //     item.childMenus.map((val) => {
      //       funcArray.push(val.menuName)
      //       state.childMenu.push(`${item.menuName}-${val.menuName}`)
      //     })
      //   }
      // })
      // console.log(state.childMenu)
    },
    SET_LEFT_MENU_Loading: (state, data) => {
      state.meunIsLoading = data
    },
    MATCH: (state, item) => {
      state.documentId = item.documentId
      state.menus.map((item) => {
        if (item.documentDTOList && item.documentDTOList.length) {
          for (let obj of item.documentDTOList) {
            if (obj.documentId === state.documentId) {
              state.catalogId = item.catalogId
              return false
            }
          }
        }
      })
    },
    APITODOC: (state, item) => {
      state.documentId = item.documentId
      state.catalogId = item.catalogId
    },
    SECCESS_REGISTER: (state, onoff) => {
      state.isRegSeccess = onoff
      state.isRegister = false
    },
    SECCESS_FINDPASS: (state, onoff) => {
      state.isPasSeccess = onoff
      state.isForget = false
    },
    SET_ACTIVE_KEY: (state, key) => {
      // console.log(state, key)
      state.activeKey = key
      state.panes = []
      forMenu(state.menus)
      function forMenu (Doclist) {
        for (let item of Doclist) {
          if (item.documentDTOList && item.documentDTOList.length) {
            forMenu(item.documentDTOList)
          }
          if (item.catalogId === key || item.activeKey === key) {
            if (item.catalogName) {
              // state.panes.unshift({ 'catalogName': item.catalogName })
            }
            if (item.title) {
              // state.panes.push({ 'catalogName': item.title })
            }
            return false
          }
        }
      }
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_MENUS_isLoading: (state, data) => {
      state.DocCenterMeunIsLoading = data
    },
    SET_IS_CHOICE_SUBJECT: (state, isChoiceSubject) => {
      state.isChoiceSubject = isChoiceSubject
    },
    SET_SUBJECT_ID: (state, subjectId) => {
      state.subjectId = subjectId
    },
    SET_SUBJECT_NAME: (state, subjectName) => {
      state.subjectName = subjectName
    },
    SET_IS_CREDENTIALS: (state, isCredentials) => {
      state.isCredentials = isCredentials
    },
    IS_CALLME: (state, isCallme) => {
      state.isCallme = isCallme
    },
    USER_INFO: (state, info) => {
      state.hideInfo = info
    },
    SET_TO_OTHERMENU: (state, param) => {
      state.toOtherMenu = param
    },
    SET_SERVICES: (state, services) => {
      state.services = services || []
    }
  },
  actions: {
    setMenus ({ commit }, menus) {
      commit('SET_MENUS', menus)
    },
    SetLang ({ commit }, lang) {
      return new Promise((resolve, reject) => {
        commit('SET_LANGUAGE', lang)
        loadLanguageAsync(lang)
          .then(() => {
            resolve()
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    // Logout ({ state, dispatch }) {
    //   return new Promise((resolve, reject) => {
    //     modal.confirm({
    //       title: i18nRender('common_globalcomp_exit_login_title'),
    //       content: i18nRender('common_globalcomp_exit_login_info'),
    //       okType: 'danger',
    //       okText: i18nRender('common_btn_confirm'),
    //       cancelText: i18nRender('common_btn_cancel'),
    //       onOk: () => {
    //         const { needBack } = state
    //         NoticeThirdSystem({})
    //         if (needBack) { // 在调用的地方作跳转
    //           resolve(true)
    //         } else {
    //           resolve(false)
    //         }
    //       }
    //     })
    //   })
    // },
    setActiveKey: ({ commit }, key) => {
      commit('SET_ACTIVE_KEY', key)
    },
    _SsoGetUserInfo: ({ state, commit }, reset = false) => {
      return new Promise((resolve, reject) => {
        if (state.hideInfo.userId && !reset) {
          return resolve(state.hideInfo)
        }
        SsoGetUserInfo().then(({ data, code, message }) => {
          if (code === '200') {
            console.log('data', data)
            if (data.onlineSubjectId) {
              SsoUserChooseSubject({ subjectId: data.onlineSubjectId }).then((res) => { // 主体确认
                const { code, message } = res
                if (code === '200') {
                  commit('SET_SUBJECT_ID', data.onlineSubjectId)
                  commit('SET_SUBJECT_NAME', data.companyName)
                } else {
                  openNotificationWithIcon(message)
                }
              })
            }
            // commit('SET_SUBJECT_ID', data.onlineSubjectId || null)
            commit('USER_INFO', data)
            resolve(data)
          } else {
            console.log('没有userINfo')
            router.push('/work/credentials')
            state.isCallme = false
            // openNotificationWithIcon(message)
          }
        })
      })
    },
    _SsogetUserRoleMenu: ({ state, commit, dispatch }, item) => {
      console.log('_SsogetUserRoleMenu')
      if (item.subjectId === null) { // 没有目录菜单
        console.log('没有subjectId')
        return router.push('/work/credentials')
      }
      SsoUserChooseSubject({ subjectId: item.subjectId }).then((res) => { // 主体确认
        const { code, message } = res
        if (code === '200') {
          commit('SET_SUBJECT_ID', item.onlineSubjectId)
          commit('SET_SUBJECT_NAME', item.companyName)
          commit('SET_IS_CHOICE_SUBJECT', false)
          dispatch('_SsoGetUserInfo', item.reset || false)
          // 查询菜单
          SsogetUserRoleMenu({ systemCode: 'OPEN_API_PORTAL' }).then(({ code, message, data }) => {
            if (code === '200') {
              commit('SET_LEFT_MENU', data)
              if (data === null) { // 没有目录菜单
                console.log('没有目录菜单')
                router.push('/work/credentials')
                return false
              }
              if (state.isCallme) { // 判断是正常登录还是点击预约登录
                return router.push('/callme')
              }
              console.log('state.isBuy', state.isBuy)
              if (state.isBuy) {
                commit('SET_ISBUY', false)
                return router.push('/home')
              } else {
                for (let index in data) {
                  if (index === '0') {
                    if (data[index].menuName === '资质管理') {
                      return router.push('/work/credentials')
                    } else if (data[index].menuName === '应用管理') {
                      return router.push('/work/applied')
                    } else if (data[index].menuName === '接口日志') {
                      return router.push('/work/interDiary')
                    } else if (data[index].menuName === 'API列表') {
                      return router.push('/work/api')
                    } else if (data[index].menuName === '子账号管理') {
                      return router.push('/work/childAct')
                    }
                  }
                }
              }
            } else {
              openNotificationWithIcon(message)
            }
          })
        } else {
          openNotificationWithIcon(message)
        }
      })
    },
    _SET_TO_OTHERMENU: ({ state, commit }, item) => {
      // 先判断isConfirm总状态是否为0或者是否购买过erp， 是的话再往上追溯一条数据的审核状态
      if (item.length) {
        if (item[0].isConfirm || item[0].boughtErp === 1) {
          commit('SET_TO_OTHERMENU', true)
        } else {
          commit('SET_TO_OTHERMENU', item[1]?.subjectStatus === 1)
        }
      } else {
        commit('SET_TO_OTHERMENU', false)
      }
    },
    // 获取购买过(已有)的系统
    GetOwnedSystem ({ commit, state }) {
      return new Promise((resolve, reject) => {
        QuerySystemExtListForSub({ paging: false, serviceCode: 'ERP+' }).then(({ dataList }) => {
          const services = dataList?.[0]?.serviceInfoExt || []
          commit('SET_SERVICES', services.filter(item => item.systemName !== 'TMS'))
          resolve(services)
        }).catch((err) => {
          reject(err)
        })
      })
    }
  }
}

export default isLogin
